import { Filters } from '../../../model/Filters'

const all = ['idv-patients']
const lists = [...all, 'idv-list']
const list = (filters?: Filters) => [...lists, filters]
const detail = (id: number) => [...all, id]
const create = [...all, 'idv-create']
const update = [...all, 'idv-update']
const merge = [...all, 'idv-merge']
const deleteItem = [...all, 'idv-deleteItem']

export const idVigilanceKeys = {
  all,
  lists,
  list,
  detail,
  create,
  update,
  merge,
  deleteItem,
}
